export default {
	name: 'RecordFilters',
	options: {

		table: 'v_search_filters',
		schema: 'server',
		sortfield: 'name'
	}
};
